export default __webpack_public_path__ + "media/copilotFreStep2.0a5a1515.webp";